import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import './assets/css/theme-mindm.css'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import messages from './locales'
import vClickOutside from "click-outside-vue3"
import './assets/css/VueTimepicker.css'
import VueAwesomePaginate from "vue-awesome-paginate"
import "vue-awesome-paginate/dist/style.css"
import * as Sentry from "@sentry/vue"
import { initGa4 } from "./utils/ga4"


import Logo from './ui/Logo.vue'
import Button from './ui/Button.vue'
import Input from './ui/Input.vue'
import BaseInput from './ui/BaseInput.vue'
import BaseButton from './ui/BaseButton.vue'
import Icon from './ui/Icon.vue'
import Checkbox from './ui/Checkbox.vue'
import ButtonIcon from './ui/ButtonIcon.vue'
import Dropdown from './ui/Dropdown.vue'
import PhoneInput from './ui/PhoneInput.vue'
import Toggle from './ui/Toggle.vue'
import Modal from '@/ui/Modal.vue'
import Loader from './ui/Loader.vue'
import Avatar from './ui/Avatar.vue'

const i18n = createI18n({
    locale: 'ru',
    fallbackLocale: 'ru',
    messages
  })

const app = createApp(App)
const pinia = createPinia()

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
const sentryEnvironment = import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE
const sentryRelease = import.meta.env.VITE_SENTRY_RELEASE || undefined
const sentryTraceSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0)
const sentryReplaySessionSampleRate = Number(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || 0)
const sentryReplayOnErrorSampleRate = Number(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || 0)
const tracePropagationTargets = (import.meta.env.VITE_SENTRY_TRACE_TARGET || '')
  .split(',')
  .map((value: string) => value.trim())
  .filter(Boolean)

const runtimeTags = {
  service: import.meta.env.VITE_SERVICE_NAME || 'main-front',
  deploy_env: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  branch: import.meta.env.VITE_GIT_BRANCH,
  commit: import.meta.env.VITE_GIT_COMMIT,
  build_number: import.meta.env.VITE_BUILD_NUMBER,
  app_version: import.meta.env.VITE_APP_VERSION,
}

if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: sentryEnvironment,
    release: sentryRelease,
    initialScope: (scope) => {
      Object.entries(runtimeTags).forEach(([key, value]) => {
        if (value) {
          scope.setTag(key, value)
        }
      })

      return scope
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: sentryTraceSampleRate,
    tracePropagationTargets,
    replaysSessionSampleRate: sentryReplaySessionSampleRate,
    replaysOnErrorSampleRate: sentryReplayOnErrorSampleRate,
  })
}

pinia.use(({ store }) => {
    store.router = markRaw(router)
});

initGa4(router)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vClickOutside)
app.use(VueAwesomePaginate)
app.mount('#app')


app.component('Logo', Logo)
   .component('Avatar', Avatar)
   .component('b-button', Button)
   .component('b-input', Input)
   .component('base-input', BaseInput)
   .component('btn', BaseButton)
   .component('icon', Icon)
   .component('checkbox', Checkbox)
   .component('button-icon', ButtonIcon)
   .component('dropdown', Dropdown)
   .component('phone-input', PhoneInput)
   .component('toggle', Toggle)
   .component('modal', Modal)
   .component('loader', Loader);
